import React from "react";
import {Route, Switch, useRouteMatch} from "react-router-dom";
import {ScoodleTheme} from "pu-crossproduct-components/build/themes";
import {Scoodle2FASetupPage} from "../pages/scoodle/2FASetup/Scoodle2FASetupPage";
import {Scoodle2FASetupConfirmPage} from "../pages/scoodle/2FASetup/Scoodle2FASetupConfirmPage";
import {Scoodle2FAPage} from "../pages/scoodle/2FA/Scoodle2FAPage";
import {Scoodle2FAFailedPage} from "../pages/scoodle/2FA/Scoodle2FAFailedPage";
import {Scoodle404} from "../components/05pages/scoodle/Scoodle404/Scoodle404";
import { useTranslation } from "react-i18next";

function getFaviconEl(id:string):HTMLLinkElement {
    return document.getElementById(id) as HTMLLinkElement;
}

function getTitleEl():HTMLTitleElement {
    return document.getElementById("page-title") as HTMLTitleElement;
}

export const ScoodleRouter: React.FC = props => {
    const {url} = useRouteMatch();
    const { t } = useTranslation();

    const faviconEl = getFaviconEl("favicon"); // Accessing favicon element
    if (faviconEl) {    
        const faviconUrl = "/scoodle-favicon.ico"
        faviconEl.href = faviconUrl;
    }

    const appleFaviconEl = getFaviconEl("apple-favicon"); // Accessing apple-favicon element
    if (appleFaviconEl) {    
        const faviconUrl = "/scoodle-logo192.png"
        appleFaviconEl.href = faviconUrl;
    }

    const titleEl = getTitleEl(); // Accessing favicon element
    if (faviconEl) {    
        titleEl.innerHTML = t("twoFactorScoodleWindowTitle");
    }

    return (<ScoodleTheme>
        <Switch>
            <Route exact={true} path={`${url}/2FA/Setup`}>
                <Scoodle2FASetupPage />
            </Route>

            <Route exact={true} path={`${url}/2FA/SetupConfirm`}>
                <Scoodle2FASetupConfirmPage />
            </Route>

            <Route exact={true} path={`${url}/2FA`}>
                <Scoodle2FAPage />
            </Route>

            <Route exact={true} path={`${url}/2FA/Failed`}>
                <Scoodle2FAFailedPage />
            </Route>

            <Route path={[`${url}/`, `${url}/*`]}>
                <Scoodle404/>
            </Route>
        </Switch>
    </ScoodleTheme>)
}
